module.exports = __webpack_public_path__ + "static/media/clipboard-prescription.59c4c520.svg";